export class Consts {
  static readonly SESSION_KEY_AUTH = 'jushin'
  static readonly API_BASE_URL = {
    // development: 'https://v8f7fttrm0.execute-api.ap-northeast-1.amazonaws.com/dev/api',
    development: 'http://127.0.0.1:8000/api',
    production: 'https://v8f7fttrm0.execute-api.ap-northeast-1.amazonaws.com/prod/api'
  }
  static readonly SESSION_KEY_TOKEN = 'token'
}
